import { combineReducers } from 'redux'
import configureStore from './CreateStore'
import rootSaga from '../sagas'

/* ------------- Assemble The Reducers ------------- */
export const reducers = combineReducers({
  user: require('./UserRedux').reducer,
  customer: require('./CustomerRedux').reducer,
  notification: require('./NotificationRedux').reducer,
  assetStorage: require('./AssetStorageRedux').reducer,
  domain: require('./DomainRedux').reducer,
  organization: require('./OrganizationRedux').reducer,
  property: require('./PropertyRedux').reducer,
  asset: require('./AssetRedux').reducer,
  assetTransaction: require('./AssetTransactionRedux').reducer
})

const rootReducer = (state, action) => {
  return reducers(state, action)
}

export default () => {
  let { store, sagasManager, sagaMiddleware } = configureStore(rootReducer, rootSaga)

  if (module.hot) {
    module.hot.accept(() => {
      const nextRootReducer = require('./').reducers
      store.replaceReducer(nextRootReducer)

      const newYieldedSagas = require('../sagas').default
      sagasManager.cancel()
      sagasManager.done.then(() => {
        sagasManager = sagaMiddleware.run(newYieldedSagas)
      })
    })
  }

  return store
}
